import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Table from 'apollo-react/components/Table';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { batch, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { columns } from './components/columns';
import {
  clearEntityHistoryDialog,
  fetchEntityHistory,
  setOpenEntityHistoryDialog,
} from '../../actions/EntityHistoryActions';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import {
  getEntityHistoryIsOpen,
  getEntityHistoryRows,
} from '../../selectors/EntityHistorySelectors';

const useStyles = makeStyles({
  content: {
    border: 'solid 1px #e9e9e9',
    '& thead > tr > th:nth-child(1) > svg': {
      display: 'none !important',
    },
    '& thead > tr > th:last-child > svg': {
      display: 'none !important',
    },
  },
  modal: {
    width: '80%',
    maxWidth: 'unset',
  },
});

const EntityHistoryDialog = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const translateString = useTranslation();
  const location = useLocation();
  const queryString = location.search;

  const { itmId } = qs.parse(queryString) || {};
  const isOpen = useFormSelector(getEntityHistoryIsOpen);
  const rows = useFormSelector(getEntityHistoryRows);
  const [isLoading, setLoading] = useState(false);
  const rowsPerPageOptions = [5, 10, 15, 'All'];

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await dispatch(fetchEntityHistory(itmId));
      setLoading(false);
    }

    isOpen && itmId && fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleModalClose = () => {
    batch(() => {
      dispatch(clearEntityHistoryDialog());
      dispatch(setOpenEntityHistoryDialog(false));
    });
  };

  const buttonProps = [
    {
      variant: 'secondary',
      label: translateString('Close'),
      onClick: () => {
        handleModalClose();
      },
    },
  ];

  const title = isLoading ? '' : translateString('Entity History');

  return (
    <Modal
      buttonProps={buttonProps}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
      disablePortal
      onClose={() => handleModalClose()}
      open={isOpen}
      title={title}
      variant="default"
    >
      <div className={classes.content}>
        <Table
          columns={columns}
          rows={rows.map((row) => ({
            ...row,
          }))}
          rowsPerPageOptions={rowsPerPageOptions}
          showFilterIcon
          isLoading={isLoading}
          initialSortedColumn="SSE_VERSION"
          initialSortOrder="desc"
        />
      </div>
    </Modal>
  );
};

export default EntityHistoryDialog;
